export default __webpack_public_path__ + "static/media/404.8f706e47.svg";